<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Creating New Order Status</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <odd-label>Internal Label</odd-label>
        <d-input
          v-model="internalLabel"
          :state="validInternalLabel ? null : false"
          class="mb-2"
        />
        <small>This is what staff sees</small>
        <small v-if="!validInternalLabel">An internal label is required</small>

        <odd-label>Customer Label</odd-label>
        <d-input
          v-model="customerLabel"
          :state="validCustomerLabel ? null : false"
          class="mb-2"
        />
        <small>This is what your customer sees</small>
        <small v-if="!validCustomerLabel">A customer label is required</small>


        <odd-label>Step Number</odd-label>
        <d-input
          v-model="stageNumber"
          type="number"
          min="1" max="1000000"
          :state="validStageNumber ? null : false"
          class="mb-2"
        />
        <small>This is the order that you will complete this step</small>
        <small v-if="!validStageNumber">Step number must be greater than 1</small>

        <odd-label>Color</odd-label>
        <div>
          <template v-for="color in COLORS">
            <d-form-radio inline :key="color" v-model="selectedColor" :value="color" :style="`color: #${color} !important; font-size: 1.1em; font-weight: 600;`">
              #{{color}}
            </d-form-radio>
          </template>
        </div>
        <small>[future feature] Makes it easier to identify orders</small>
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="insertOrderStatus"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>

let COLORS = [
  "000000",
  "0ea7b5",
  "0c457d",
  "0084ff",
  "8ec127",
  "d11141",
  "00b159",
  "f37735",
  "ffc425",
  "36454f",
  "ff48c4",
  "2bd1fc",
  "c04df9",
  "ff3f3f",
  "7ddc1f",
];

COLORS = COLORS.sort()

export default {
  data() {
    return {
      internalLabel: "",
      customerLabel: "",
      stageNumber: 1,
      selectedColor: "000000",
      COLORS: COLORS,
      saving: false,
      validInternalLabel: true,
      validCustomerLabel: true,
      validStageNumber: true,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  watch: {
    showModal() {
      this.resetForm();
    }
  },
  methods: {
    resetForm() {
      this.internalLabel = "";
      this.customerLabel = "";
      this.stageNumber = 1;
      this.selectedColor = "000000";
      this.saving = false;
      this.validInternalLabel = true;
      this.validCustomerLabel = true;
      this.validStageNumber = true;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    validateInternalLabel() {
      this.validInternalLabel = 3 < this.internalLabel.length && this.internalLabel.length < 50;
    },
    validateCustomerLabel() {
      this.validCustomerLabel = 3 < this.customerLabel.length && this.customerLabel.length < 50;
    },
    validateStageNumber() {
      this.validStageNumber = typeof this.stageNumber === 'number' && this.stageNumber >= 1
    },
    validate() {
      this.validateInternalLabel();
      this.validateCustomerLabel();
      return this.validInternalLabel && this.validCustomerLabel;
    },
    insertOrderStatus() {
      if (this.validate()) {
        this.saving = true;
        const orderStatus = {
          internal_label: this.internalLabel,
          customer_label: this.customerLabel,
          hex_color: this.selectedColor,
        };
        this.$store
          .dispatch("orderStatusOptions/insert", orderStatus)
          .then(result => {
            this.saving = false;
            this.$emit("dataUpdated");
            this.handleClose();
          });
      }
    }
  }
};
</script>

<style></style>
